import Http, { getUrl } from '../http';

const prefix = 'instagram-feed';

function websiteParam(website) {
  if (!website) {
    return null;
  }
  if (typeof website === 'string' || typeof website === 'number') {
    return website;
  }
  return website.encrypted_id || website.id;
}

export const getOAuthUrl = (website) => {
  const websiteId = websiteParam(website);
  return Http.authApi().get(`${prefix}/oauth/url`, {
    params: { website_id: websiteId },
  });
};

export const getConnection = (website) => {
  const websiteId = websiteParam(website);
  return Http.authApi().get(`${prefix}/connection/${encodeURIComponent(websiteId)}`);
};

export const disconnect = (website) => {
  const websiteId = websiteParam(website);
  return Http.authApi().delete(`${prefix}/connection/${encodeURIComponent(websiteId)}`);
};

export const selectAccount = (website, igUserId) => {
  const websiteId = websiteParam(website);
  return Http.authApi().post(`${prefix}/oauth/select-account`, {
    website_id: websiteId,
    ig_user_id: igUserId,
  });
};

export const getFeed = (website, { limit = 9, cursor = null } = {}) => {
  const websiteId = websiteParam(website);
  const params = { limit };
  if (cursor) {
    params.cursor = cursor;
  }
  return Http.authApi().get(`${prefix}/feed/${encodeURIComponent(websiteId)}`, { params });
};

export function isInstagramOAuthMessageOrigin(origin) {
  if (!origin) {
    return false;
  }

  try {
    return origin === new URL(getUrl()).origin;
  } catch (e) {
    return false;
  }
}



// WEBPACK FOOTER //
// ./src/js/services/integrations-internas/instagramFeed.js